import AuthComponent from "@components/auth/component";
import NoRecord from "@components/layouts/NoRecord";
import PageWrapper from "@components/layouts/PageWrapper";
import TableSkeleton from "@components/layouts/TableSkeleton";
import { sliderColumns } from "@helpers/columns/cms/slider-managment.columns";
import { DeletePopup } from "@helpers/popups/DeletePopup";
import { Toast } from "@helpers/popups/Toast";
import useGetPermission from "@hooks/common/useGetPermission";
import { useDidMountEffect } from "@hooks/useDidMountEffect";
import { useErrorHandling } from "@hooks/useErrorHandling";
import usePagination from "@hooks/usePagination";
import {
  useDeleteSliderMutation,
  useGetAllSliderQuery,
} from "@states/cms/slider.api";
import { TDeleteSuccesResponse } from "@type-defs/general/TDeleteSuccessResponse";
import { TFailResponse } from "@type-defs/general/TFailResponse";
import { SLIDER_MANAGEMENT } from "@utils/constants/slider-management/slider-management.constants";
import { castTypeArr } from "@utils/general/cast-type";
import { useEffect } from "react";
import DataTable from "react-data-table-component";

function SliderPage() {
  const { hasAccess } = useGetPermission();
  const { page, limit, handlePageChange, handlePerRowsChange } =
    usePagination();
  const {
    data,
    isFetching,
    error: getAllError,
    refetch,
  } = useGetAllSliderQuery({
    page,
    limit,
  });
  const [deleteSlider, { error: deleteError, isLoading }] =
    useDeleteSliderMutation();
  useErrorHandling(...castTypeArr<TFailResponse>([getAllError, deleteError]));

  useEffect(() => {
    refetch();
  }, []);

  useDidMountEffect(() => {
    refetch();
  }, [page, limit]);

  const deleteHandler = async (id: number | string) => {
    try {
      const { isConfirmed } = await DeletePopup.fire();

      if (isConfirmed) {
        const res = await deleteSlider(id);

        const successData = "data" in res ? res.data : null;
        const { success, message } = successData as TDeleteSuccesResponse;

        if (success) {
          Toast.fire({
            icon: "success",
            title: message,
          });

          refetch();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // console.table(data);

  return (
    <AuthComponent
      action="view"
      module="CMS"
      subModule="Slider Management"
      page
    >
      <PageWrapper
        addPath={SLIDER_MANAGEMENT.ADD_PATH()}
        addButtonTitle={SLIDER_MANAGEMENT.ADD_BUTTON_TITLE}
        title={SLIDER_MANAGEMENT.LIST_PAGE_TITLE}
        hasCreatePermission={hasAccess("create", "CMS", "Slider Management")}
      >
        <DataTable
          keyField="slider_id"
          responsive
          striped
          pagination
          paginationServer
          //@ts-ignore
          paginationTotalRows={data?.paginator?.totalItems}
          progressPending={isFetching}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          noDataComponent={<NoRecord />}
          progressComponent={<TableSkeleton actionRight row={10} col={5} />}
          //@ts-ignore
          columns={sliderColumns(deleteHandler)}
          //@ts-ignore
          data={data?.data}
        />
      </PageWrapper>
    </AuthComponent>
  );
}

export default SliderPage;
